
const data = [
  {
    title: '政府类项目全流程申报支持概述',
    description: '为企业提供政府类项目申报全流程专业指导，提高项目申报成功率，使企业享受到应得的优惠政策。'
  },
  {
    title: '服务内容',
    description: '政策宣导及解读\n' +
      '材料准备及整理\n' +
      '方案撰写\n' +
      '答辩协同\n' +
      '审查指导'
  },
  {
    title: '服务特点',
    description: '进度实时查询，申报成功率高。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/product-support.js